export * from "./avatar";
export * from "./bornInfo";
export * from "./careerStation";
export * from "./deathInfo";
export * from "./name";
export * from "./nameArticle";
export * from "./orgInfo";
export * from "./quote";
